<template>
  <v-card flat>
    <v-menu
      bottom
      offset-y
      nudge-bottom="5"
      v-model="actionType"
      max-height="500"
      :disabled="count <= 0 && valueComputed === 'all'"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn text v-on="on" v-bind="attrs" v-if="typeContent">
          <v-badge
            v-if="typeContent.pro"
            color="transparent"
            overlap
            offset-x="24"
            offset-y="6"
          >
            <template #badge>
              <v-icon color="grey darken-3" size="12" class="glow-crown">mdi-crown</v-icon>
            </template>
            <img
              v-if="typeContent.image"
              :src="typeContent.image"
              class="me-2 icon-list-type-img"
              style="width: 18px; height: 18px; object-fit: contain; vertical-align: middle;"
            />
            <!-- اگر آیکون MDI داشت -->
            <v-icon v-else class="me-2 icon-list-type" left color="grey darken-3" size="18">
              mdi-{{ typeContent.icon }}
            </v-icon>
          </v-badge>


          <template v-else>
            <img
              v-if="typeContent.image"
              :src="typeContent.image"
              class="me-2 icon-list-type-img"
              style="width: 19px; height: 19px; object-fit: contain; vertical-align: middle;"
            />
            <v-icon v-else class="me-2 icon-list-type" left color="grey darken-3" size="19">
              mdi-{{ typeContent.icon }}
            </v-icon>
          </template>

          {{ typeContent.name }}

          <v-fade-transition mode="out-in">
            <v-icon class="ms-2" key="down" v-if="!actionType">mdi-chevron-down</v-icon>
            <v-icon class="ms-2" key="up" v-else>mdi-chevron-up</v-icon>
          </v-fade-transition>
        </v-btn>
      </template>

      <!-- بخش لیست کشویی -->
      <v-list dense>
        <template v-for="(item, i) in translatedItemsType">
          <v-list-item
            :key="i"
            color="primary"
            @click="valueComputed = item.value"
            v-if="item.value.toLowerCase() !== valueComputed.toLowerCase()"
          >
            <v-list-item-icon>
              <!-- حالت ویژه (دارای نشان PRO) در لیست -->
              <v-badge
                v-if="item.pro"
                color="transparent"
                overlap
                offset-x="24"
                offset-y="6"
              >
                <template #badge>
                  <v-icon color="grey darken-3" size="12" class="glow-crown">mdi-crown</v-icon>
                </template>
                <img
                  v-if="item.image"
                  :src="item.image"
                  class="me-2 icon-list-type-img"
                  style="width: 19px; height: 19px; object-fit: contain;"
                />
                <v-icon v-else class="me-2 icon-list-type" color="grey darken-3" size="19">
                  mdi-{{ item.icon }}
                </v-icon>
              </v-badge>

              <!-- حالت عادی در لیست -->
              <template v-else>
                <img
                  v-if="item.image"
                  :src="item.image"
                  class="me-2 icon-list-type-img"
                  style="width: 20px; height: 20px; object-fit: contain;"
                />
                <v-icon v-else class="me-2 icon-list-type" color="grey darken-3" size="20">
                  mdi-{{ item.icon }}
                </v-icon>
              </template>
            </v-list-item-icon>

            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>

    <!-- دکمه حذف فیلتر -->
    <v-tooltip top v-if="valueComputed !== 'all'">
      <template v-slot:activator="{ on, attr }">
        <v-btn icon @click="valueComputed = 'all'" v-on="on" v-bind="attr">
          <v-icon>mdi-filter-remove</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("headerTypeFilter.all_qr_models") }}</span>
    </v-tooltip>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "headerTypeFilter",
  props: {
    value: String,
    count: Number,
    type: { type: String, default: "" },
  },
  data: () => ({
    actionType: false,
    itemsType: [],
  }),
  mounted() {
    this.itemsType = [
      {
        name: this.$t("headerTypeFilter.qr_model"),
        value: "all",
        icon: "filter",
      },
      ...this.getQrTypes(),
    ];
  },
  computed: {
    translatedItemsType() {
      return this.itemsType.map((item) => ({
        ...item,
        name: this.$t(`${item.name}`),
      }));
    },
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        if (this.type === "group") {
          this.updateTypeFiltergroup(val);
        } else {
          this.updateTypeFilter(val);
        }
      },
    },
    typeContent() {
      return this.translatedItemsType.find(
        (item) => item.value.toLowerCase() === this.valueComputed.toLowerCase()
      );
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.itemsType = [
          {
            name: this.$t("headerTypeFilter.qr_model"),
            value: "all",
            icon: "filter",
            pro: false,
          },
          ...this.getQrTypes(),
        ];

        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions("localstorage", [
      "updateTypeFilter",
      "updateTypeFiltergroup",
    ]),
  },
};
</script>

<style scoped>
.icon-list-type-img {
  display: inline-block;
}
</style>
